export default __webpack_public_path__ + "logo.3ba297ef541819d619783624c69f704b.png";